

import React, { Component, useEffect, useRef, useState } from 'react';
import { ActivityIndicator, Image, ScrollView,  Share } from 'react-native';
import { Text, Button, Tab, Tabs, Container, Icon,View, ListItem, Body, Card, CardItem, NativeBaseProvider, Spinner, } from 'native-base';
//import { withNavigationFocus, NavigationEvents } from 'react-navigation';
import { FontAwesome5 } from '@expo/vector-icons';

import db, { getUserPath } from '../acebase';
import { isLocalDatabase, liveTTScoreboardButtonTextColor, liveTTScoreboardColor } from '../../livettscoreboard.config';
import { liveTTScoreboardTheme } from "../liveTTScoreboardTheme";



export default function LoadingPage(){

    let [paddleNumber, setPaddleNumber] = useState(0)
    let counter = useRef(0)
    let [failedToLoad, setFailedToLoad] = useState(false)

    useEffect(()=>{
        let intervalID = setInterval(()=>{
                counter.current = counter.current+1
                setPaddleNumber(counter.current%4)
                if(counter.current === 20){
                    setFailedToLoad(true)
                }
            
        }, 500)

        return ()=>{
            clearInterval(intervalID)
        }
    }, [])

    return (
        <NativeBaseProvider theme={liveTTScoreboardTheme}>
            <View justifyContent={"center"} height="100%" width={"100%"} flex={1} alignItems="center">
                {
                    failedToLoad ?
                    <>
                    <Text fontSize={"5xl"} color={liveTTScoreboardColor}>Failed To Load.</Text>
                    <Text color={liveTTScoreboardColor}>Please try again later.</Text>
                    </>
                    
                    :
                    <>
                    <Text fontSize={"5xl"} color={liveTTScoreboardColor}>Loading{
                    paddleNumber >=1 ?
                    <FontAwesome5 name="table-tennis" size={24} color={liveTTScoreboardColor} />
                    : "."
                }{
                    paddleNumber >=2 ?
                    <FontAwesome5 name="table-tennis" size={24} color={liveTTScoreboardColor} />
                    : "."
                }
                {
                    paddleNumber >=3 ?
                    <FontAwesome5 name="table-tennis" size={24} color={liveTTScoreboardColor}/>
                    : "."
                }</Text>
                    </>
                }
                
                
            </View>
        </NativeBaseProvider>
    )
}